import {DataTableCellProps, TemporalFormat, tryParseInstant} from "@variocube/app-ui";
import React from "react";
import {BookingShare} from "../../../api";

export function BookingShareCreatedCell({row}: DataTableCellProps<BookingShare>) {
	const created = tryParseInstant(row.created);
	return created ? <TemporalFormat value={created} /> : null;
}
